/* eslint-disable prettier/prettier */
import request from '@/utils/request'

// 获取供应商认定结果审批基本信息
export function supplierResultBase(identifyCode) {
    return request({
        url: `/api/srm-slcm/suppIdentifyResult/selectIdentifyResultByIdForApp/${identifyCode}`,
        method: 'get'
    })
}

// 获取供应商认定结果审批申请明细信息
export function supplierResultApply(resultApplyCode) {
    return request({
        url: `/api/srm-slcm/suppIdentifyResult/selectIdentifyResultDetailForApp/${resultApplyCode}`,
        method: 'get'
    })
}

// 获取供应商认定结果审批结论明细信息
export function supplierResultConclusion(resultApplyCode) {
    return request({
        url: `/api/srm-slcm/suppIdentifyResult/selectIdentifyResultReviewForApp/${resultApplyCode}`,
        method: 'get'
    })
}